window.TCB_LUNATRACK = window.TCB_LUNATRACK || {};
window.TCB_LUNATRACK['exposure'] = window.TCB_LUNATRACK['exposure'] || {};

export function initExposure(options = {}) {
    try {
        createExposure({
            key: 'default',
            type: 'offset',
            options
        });
    } catch (error) {
        console.log('luna-track initExposure-error:', error);
    }
}

export function createExposure({key, type, options} ={}) {
    try {
        let ExposureClass = null;
        switch (type) {
        case 'offset':
            ExposureClass = window.$Exposure.ExposureUseOffset;
            break;
        case 'observer':
            ExposureClass = window.$Exposure.ExposureUseObserver;
            break;
        default:
            break;
        }
        const exposure = new ExposureClass(options);
        window.TCB_LUNATRACK.exposure[key] = exposure;
    } catch (error) {
        console.log('luna-track createExposure-error:', error);
    }
}
export function removeExposure({key = 'default'} ={}) {
    try {
        if (window.TCB_LUNATRACK.exposure[key]) {
            delete window.TCB_LUNATRACK.exposure[key];
        }
    } catch (error) {
        console.log('luna-track removeExposure-error:', error);
    }
}

export function exposureListen({key = 'default'} = {}) {
    try {
        const exposure = window.TCB_LUNATRACK['exposure'] ? window.TCB_LUNATRACK['exposure'][key] : null;
        if (exposure) {
            exposure.listen();
        }
    } catch (error) {
        console.log('luna-track exposureListen-error:', error);
    }
}

// 更新实例属性,如rootMargin
export function exposureUpdateProperty({key = 'default', options ={}} = {}) {
    try {
        const exposure = window.TCB_LUNATRACK['exposure'] ? window.TCB_LUNATRACK['exposure'][key] : null;
        if (exposure) {
            exposure.updateProperty(options);
        }
    } catch (error) {
        console.log('luna-track exposureUpdateProperty-error:', error);
    }
}

// 构建偏移量 rootMargin
export function buildRootMargin(options) {
    try {
        // options格式:存放影响偏移量的元素id
        // const {top = [id,id],bottom = [],left = [],right = []} = options
        const margin = {};
        let key;
        for (key in options) {
            const ids = options[key];
            let h = 0;
            ids.forEach((id) => {
                const el = document.getElementById(id);
                if (el) {
                    h += el.clientHeight;
                }
            });
            margin[key] = h;
        }
        const {top = 0, bottom = 0, left = 0, right = 0} = margin;
        return [top, right, bottom, left];
    } catch (error) {
        console.log('luna-track buildRootMargin-error:', error);
    }
}

export function exposureUpdate({key = 'default'} ={}) {
    try {
        const exposure = window.TCB_LUNATRACK['exposure'] ? window.TCB_LUNATRACK['exposure'][key] : null;
        if (exposure) {
            exposure.update();
        }
    } catch (error) {
        console.log('luna-track exposureListen-error:', error);
    }
}

export function exposureRegister({key = 'default',el,log = {},elementParamData} = {}) {
    try {
        const exposure = window.TCB_LUNATRACK['exposure'] ? window.TCB_LUNATRACK['exposure'][key] : null;
        let elementParamLog = {};
        if (typeof elementParamData === 'object') {
            elementParamLog = exposure.buildElementParamLog(elementParamData);
        }
        if (exposure) {
            exposure.register({
                el,
                log:{
                    ...log,
                    ...elementParamLog
                }
            });
        }
    } catch (error) {
        console.log('luna-track exposureRegister-error:', error);
    }
}
